import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';

import { Global, ThemeProvider } from '@emotion/react';

import App from './App';
import { GlobalErrorBoundary } from './components/ErrorBoundary';
import GlobalStyles, { theme } from './globalStyles';
import { interceptors } from './interceptors';
import store from './redux/store';
import reportWebVitals from './reportWebVitals';

interceptors.authInterceptor();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  <HelmetProvider>
    <GlobalErrorBoundary>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <Global styles={GlobalStyles} />
          <App />
        </ThemeProvider>
      </Provider>
    </GlobalErrorBoundary>
  </HelmetProvider>
  // </React.StrictMode>
);

reportWebVitals();
